import { render, staticRenderFns } from "./postApplicant.vue?vue&type=template&id=7a8f128d&scoped=true"
import script from "./postApplicant.vue?vue&type=script&lang=js"
export * from "./postApplicant.vue?vue&type=script&lang=js"
import style0 from "./postApplicant.vue?vue&type=style&index=0&id=7a8f128d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8f128d",
  null
  
)

export default component.exports